import {
  verifyEither_default
} from "./chunk-F55FDC7O.mjs";
import {
  verifyMaybe_default
} from "./chunk-M5FJK2RG.mjs";
import {
  isNotUndefined_default
} from "./chunk-ZNK2UXVC.mjs";

// src/monet-utils/verifyMonad.ts
import { match, when } from "ts-pattern";
function verifyMonad(val) {
  return match(val).with({ isNone: when(isNotUndefined_default) }, verifyMaybe_default).with({ isRight: when(isNotUndefined_default) }, verifyEither_default).with({ "@@type": "monet.js/Maybe" }, verifyMaybe_default).with({ "@@type": "monet.js/Either" }, verifyEither_default).otherwise((__) => val);
}
var verifyMonad_default = verifyMonad;

export {
  verifyMonad_default
};
//# sourceMappingURL=chunk-RXIADIQN.mjs.map